import React, { Component, Fragment } from 'react';
import PropTypes from "prop-types";
import Icofont from 'react-icofont';
import ScrollAnimation from 'react-animate-on-scroll';
import CountUp from 'react-countup';
import VisibilitySensor from "react-visibility-sensor";

class About extends Component {
    state = {
        didViewCountUp: false
    };

    onVisibilityChange = isVisible => {
        if (isVisible) {
            this.setState({ didViewCountUp: true });
        }
    };
    render() {
        //About loop start
        const aboutdata = this.props.aboutsData.map((about, index) => (
            <div key={index}>
                <div className="about-info">
                    <h3><Icofont icon={about.Icon} /> {about.title}</h3>
                    <div>{about.content}</div>
                </div>
            </div>
        ));
        //About loop END
        return (
            <React.Fragment>
                <section id="about" className="about-us ptb-100">
                <div className="container">
                    <div className="row">
                        <div className="text-center">
                            <ScrollAnimation animateIn="fadeInUp">
                                <div className="section-title">
                                    <h2>{this.props.sectionTitle}</h2>
                                    <p className="section-desc">{this.props.sectionDescription}</p>
                                    <span className="section-title-bg">{this.props.SectionbgTitle}</span>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                    
                    <div className="row">
                        {aboutdata}
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="count-box text-center">
                                <div className="glyph">
                                    <Icofont icon="icofont-users-social" />
                                </div>
                                <p>追蹤人數</p>
                                <h2 className="counter">
                                <VisibilitySensor
                                    onChange={this.onVisibilityChange}
                                    offset={{
                                        top: 10
                                    }}
                                    delayedCall
                                >
                                    <CountUp
                                        start={0}
                                        end={
                                            this.state.didViewCountUp
                                                ? 474
                                                : 0
                                        }
                                        duration={3}
                                    /> 
                                </VisibilitySensor>K
                                </h2>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4">
                            <div className="count-box text-center">
                                <div className="glyph">
                                    <Icofont icon="icofont-video-cam" />
                                </div>
                                <p>每月直播次數</p>
                                <h2 className="counter">
                                <VisibilitySensor
                                    onChange={this.onVisibilityChange}
                                    offset={{
                                        top: 10
                                    }}
                                    delayedCall
                                >
                                    <CountUp
                                        start={0}
                                        end={
                                            this.state.didViewCountUp
                                                ? 500
                                                : 0
                                        }
                                        duration={3}
                                    />
                                </VisibilitySensor>+
                                </h2>
                            </div>
                        </div>

                        <div className="col-lg-4 col-md-4">
                            <div className="count-box text-center">
                                <div className="glyph">
                                    <Icofont icon="icofont-labour" />
                                </div>
                                <p>記者人數</p>
                                <h2 className="counter">
                                <VisibilitySensor
                                    onChange={this.onVisibilityChange}
                                    offset={{
                                        top: 10
                                    }}
                                    delayedCall
                                >
                                    <CountUp
                                        start={0}
                                        end={
                                            this.state.didViewCountUp
                                                ? 10
                                                : 0
                                        }
                                        duration={3}
                                    />
                                </VisibilitySensor>+
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>   
            </React.Fragment>
        );
    }
}
//Props Types
About.propTypes = {
    SectionbgTitle: PropTypes.string,
    sectionTitle: PropTypes.string,
    sectionDescription: PropTypes.string,
    aboutsData: PropTypes.array
};

//Default Props
About.defaultProps = {
    SectionbgTitle: "About",
    sectionTitle: "關於我們",
    sectionDescription:
        "高登新聞台於2019年正式成立。我們透過沉澱多年經營論壇的經驗，分析時下網絡媒體的發展，以嶄新角度為觀眾帶來不一樣的新聞體驗。何謂網媒？是否單單將紙本媒體的內容搬到網上，就已經足夠？我們有更長遠的規劃，更顛覆的想法，更沖擊的思考，因為我們深信最精確的資訊，需要多方面的配合及籌劃，因此我們需要你的支持。",
        aboutsData: [
        {
            Icon: "icofont-unique-idea",
            title: "成績與反思",
            content: 
                <Fragment>
                    <p>高登新聞部自7月底以來於Facebook上進行直播，專頁粉絲短短4個月內上升近15萬觀眾，每條直播片平均有4000觀眾，以網媒規模而言可謂已交出最好的成績表。在發展新聞台的每一天，我們不斷反思，除安排記者前往不同地區進行直播，將最真實的畫面交給觀眾，究竟還有什麼可以做？</p>
                    <p>答案顯然易見，我們更希望觀眾不會因直播內容而令情緒過份緊張，所以直播組同事本著初心，在高登自由的制度下培養出自己一套獨特的直播風格，既可在現場穿梭搜集素材，同時亦可安撫觀眾情緒，以免觀眾因精神過於崩緊而發生不幸事故。日後高登新聞部仍然會遵循初衷，以適當的手法報導最精確的新聞。</p>
                </Fragment>,
        },
        {
            Icon: "icofont-money",
            title: "養份及發展",
            content: 
                <Fragment>
                    <p>作為香港文化溫床的高登討論區，一眾網友不但緊貼時事，同時亦對各方面均有指涉。高登討論區現希望可以廣招人材，逐步將高登文化及風氣從討論區帶上螢幕，再將螢幕前的林林種種帶回討論區，形成一體化討論循環。</p>
                    <p>接下來的日子，我們除做直播新聞，亦會投放資源開發偵查式報導，分配人手建立國際線新聞網絡，並著手嘗試不同類型的節目，務求令觀眾隨時隨地可獲一站式資訊。</p>
                </Fragment>,
        },
    ]
};

export default About;
